import React, { createContext, useContext, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userEmail, setUserEmail] = useState('');
  const [userPlanTier, setUserPlanTier] = useState(null);

  return (
    <UserContext.Provider value={{ userEmail, setUserEmail, userPlanTier, setUserPlanTier }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
